import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';

const ScrollButton = styled(ButtonBase)`
    position: absolute;
    width: 44px;
    height: 44px;
    background-color: white;
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;

    :hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
    }
`;

const ScrollGradient = styled.div`
    position: absolute;
    height: 100%;
    width: 120px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
`;

export const ScrollRightButton = styled(ScrollButton, {
    shouldForwardProp: prop => prop !== 'scrollButtonPadding',
})<{ scrollButtonPadding?: number }>`
    right: calc(-22px + ${({ scrollButtonPadding }) => scrollButtonPadding || 0}px);
`;

export const ScrollRightButtonGradient = styled(ScrollGradient, {
    shouldForwardProp: prop => prop !== 'scrollButtonPadding',
})<{ scrollButtonPadding?: number }>`
    right: calc(-32px + ${({ scrollButtonPadding }) => scrollButtonPadding || 0}px);
    background: ${({ theme }) => `linear-gradient(270deg, ${theme.colors.black[50]} 15.22%, rgba(255, 255, 255, 0) 100%)`};
`;

export const ScrollLeftButton = styled(ScrollButton, {
    shouldForwardProp: prop => prop !== 'scrollButtonPadding',
})<{ scrollButtonPadding?: number }>`
    left: calc(-22px + ${({ scrollButtonPadding }) => scrollButtonPadding || 0}px);
`;

export const ScrollLeftButtonGradient = styled(ScrollGradient, {
    shouldForwardProp: prop => prop !== 'scrollButtonPadding',
})<{ scrollButtonPadding?: number }>`
    left: calc(-32px + ${({ scrollButtonPadding }) => scrollButtonPadding || 0}px);
    background: ${({ theme }) => `linear-gradient(90deg, ${theme.colors.black[50]} 15.22%, rgba(255, 255, 255, 0) 100%)`};
`;
